// extracted by mini-css-extract-plugin
module.exports = {"nav":"menu_nav__pSeyc","disabled":"menu_disabled__lmMX2"};